import React from "react"
import { useLabels } from "../../../../../features/contents/hooks"
import Typography from "../../../../../ui/atoms/Typography"
import ExpandableMenu from "../../../../../ui/molecules/ExpandableMenu"
import { useAlgoliaSearchState } from "../../controller/state"
import BrandFilterOptions from "../BrandFilterOptions"
import { FacetOption } from "../types"

const hasSelectedItems = (items: FacetOption[]) => items.some((x) => x.selected)

export const BrandSidebarFilter = () => {
  const [expanded, setExpanded] = React.useState(false)
  const [initialized, setInitialized] = React.useState(false)

  const { getLabel } = useLabels()
  const { uiFilters } = useAlgoliaSearchState()
  const brands = uiFilters?.brands

  React.useEffect(() => {
    if (!initialized && brands && brands.length > 0) {
      setInitialized(true)
      setExpanded(hasSelectedItems(brands))
    }
  }, [brands])

  if (!brands || brands.length <= 1) {
    return <></>
  }

  return (
    <ExpandableMenu
      label={
        <Typography
          variant="body1"
          weightValue={500 as any}
          textClassName="uppercase mb-2"
        >
          {getLabel("search", "brand-filter")}
        </Typography>
      }
      expanded={expanded}
      onToggle={setExpanded}
      className="mt-1"
    >
      <BrandFilterOptions maxScrollItems={10} minTextFilterItems={60} />
    </ExpandableMenu>
  )
}
